import Stack from '@mui/material/Stack';

import ButtonWrapper from '@webclient/components/minimal-bot-creation-modal/components/footer/button-wrapper';

type Props = {
  SkipButton?: React.ReactNode;
  BackButton?: React.ReactNode;
  NextButton?: React.ReactNode;
};

export default function Footer({ BackButton, NextButton, SkipButton }: Props) {
  return (
    <ButtonWrapper>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
        }}
      >
        {SkipButton}
        <Stack
          direction="row"
          gap={3}
        >
          {BackButton}
          {NextButton}
        </Stack>
      </Stack>
    </ButtonWrapper>
  );
}
